<template>
  <div class="thank-you">
    <!-- TODO добавить перевод -->
    <h1>Thank you for purchase!</h1>
    <!-- <h1>{{$ml.get(`Thank you for purchase!`)}}</h1> -->
  </div>
</template>

<script>
export default {
  created() {
    // @FACEBOOK-PIXEL
    fbq('track', 'Purchase');
    // @Google tag Manager
    gtag('event', 'conversion', {'send_to': 'AW-764874558/0E3MCLuugscBEL6e3OwC'});
  }
}
</script>

<style lang="scss" scoped>
h1 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

}
</style>
